import {Heading, Image, HeadingProps} from '@chakra-ui/react';
import {IMAGE_PREFIX} from '../env';

type Props = HeadingProps & {
  number: number,
};

export const STICKING_OUT = `${126/16}rem`;
export const STICKING_OUT_SM = `${80/16}rem`

export default function StepSectionHeading({number, children, ...headingProps}: Props) {
  return (
    <Heading
      {...headingProps}
      position="relative"
      fontSize={['28px', '28px', "4xl"]}
      pt={[`${54/28}em`, `${54/28}em`, `${59/36}em`]}
      pb={[`${50/28}em`, `${50/28}em`, `${38/36}em`]}
      lineHeight={62/36}
      textAlign="center"
      backgroundColor="blue.500"
      color="white"
    >
      <Image
        src={`${IMAGE_PREFIX}ttl-graph-0${number}.png`}
        alt={`Step ${number}`}
        position="absolute"
        top={[`-${STICKING_OUT_SM}`, `-${STICKING_OUT_SM}`, `-${STICKING_OUT}`]}
        left="50%"
        transform="translateX(-50%)"
        width={[`${100/28}em`, `${145.41/36}em`]}
      />
      {children}
    </Heading>
  );
}
